// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"aa0172b4","787":"c41739af","968":"840dbca1"}[chunkId] + ".chunk.js";
};